import "./../App.css";
import TravelParks from "./experiencesPartials/parks-traveled";
import TravelStates from "./experiencesPartials/state-traveled";
import EscapeRooms from "./experiencesPartials/escape-rooms";
import Museums from "./experiencesPartials/museums";


function Experiences() {

  return (
    <>
        <TravelStates/>
        <TravelParks/>
        <EscapeRooms/>
        <Museums/>
    </>
  );
}

export default Experiences;
